module.exports = require('./lib/linkify-string').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/string.js
// module id = nN35
// module chunks = 1